import storageService from './storage-service';

// CD3E5480-2CA64850-A19AF149-BB5C2B4C

const ENV = {
	url: `${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_API_URL}`,
};

const getHeaders = () => {
	const login = storageService.load();

	return {
		accesskey: login.accessKey,
		dbkey: login.dbKey,
	};
};

export const UI_URL = `${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_BASE_URL}`;
export const API_URL = `${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_API_URL}`;

export const get = async (url, extraHeaders = {}) => {
	let response = await fetch(`${ENV.url}${url}`, {
		headers: { ...getHeaders(), ...extraHeaders },
		method: 'GET',
	});

	if (response.ok) {
		return response.json();
	}

	return {};
};

export const downloadFile = async (url, fileName) => {
	await fetch(url)
		.then((response) => response.blob())
		.then((blob) => {
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = fileName;
			link.click();
		})
		.catch((error) => console.error(error));
};

export const post = async (url, body, rawResponse = false) => {
	let response = await fetch(`${ENV.url}${url}`, {
		headers: getHeaders(),
		method: 'POST',
		body,
	});

	return rawResponse ? response : response.json();
};

export const request = async (method, url, data = null, headers = {}) => {
	const apiUrl = `${ENV.url}${url}`;
	const defaultHeaders = {
		Accept: ['application/json', 'text/plain'],

		'Content-Type': 'application/json',
		...getHeaders(),
		...headers,
	};

	const options = {
		method,
		headers: new Headers(defaultHeaders),
		mode: 'cors',
	};

	if (data) {
		options.body = JSON.stringify(data);
	}

	try {
		const response = await fetch(apiUrl, options);

		// Handle non-successful responses (e.g., 404, 500, etc.)
		if (!response.ok) {
			throw new Error(`HTTP Error: ${response.status}`);
		}

		// Check if the response has content
		const contentType = response.headers.get('Content-Type');
		if (contentType && contentType.includes('application/json')) {
			return response.json(); // Only parse JSON if response has JSON content type
		} else {
			return response.ok; // Otherwise return status text or some other placeholder
		}
	} catch (error) {
		// Handle network errors and exceptions
		console.error(`Error calling ${apiUrl}:`, error);
		throw error;
	}
};
